import types from './actionTypes';

export const resetState = () => ({
  type: types.RESET_PUSH_NOTIFICATION_STATE,
});

export const createPushNotification = (pushNotification) => ({
  type: types.CREATE_PUSH_NOTIFICATION.REQUEST,
  pushNotification,
});

export const createPushNotificationSuccess = (pushNotification) => ({
  type: types.CREATE_PUSH_NOTIFICATION.SUCCESS,
  pushNotification,
});

export const createPushNotificationFailure = (error) => ({
  type: types.CREATE_PUSH_NOTIFICATION.FAILURE,
  error,
});

export const fetchPushNotifications = (startDate, endDate) => ({
  type: types.FETCH_PUSH_NOTIFICATIONS.REQUEST,
  startDate,
  endDate,
});

export const fetchPushNotificationsSuccess = (
  pushNotifications,
  startDate,
  endDate,
) => ({
  type: types.FETCH_PUSH_NOTIFICATIONS.SUCCESS,
  pushNotifications,
  startDate,
  endDate,
});

export const fetchPushNotificationsFailure = (error) => ({
  type: types.FETCH_PUSH_NOTIFICATIONS.FAILURE,
  error,
});
